// scroll bar
import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

// React
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Query
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// MUI
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { LicenseInfo } from '@mui/x-data-grid-pro';

// contexts
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
//
import App from './App';
import { AuthProvider } from './contexts/JWTContext';
import { ConfigurationProvider } from './contexts/ConfigurationContext';

// Query Client
const queryClient = new QueryClient();

// ----------------------------------------------------------------------

LicenseInfo.setLicenseKey(
  'ae2d0415cd27f463d0e1b662f99930abTz00NDUxMyxFPTE2ODUxNzMxNzQ3MTAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

ReactDOM.render(
  <AuthProvider>
    <HelmetProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SettingsProvider>
          <ConfigurationProvider>
            <CollapseDrawerProvider>
              <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </QueryClientProvider>
            </CollapseDrawerProvider>
          </ConfigurationProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </HelmetProvider>
  </AuthProvider>,
  document.getElementById('root')
);
